"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LevelSelector = void 0;
var material_1 = require("@mui/material");
var Home_1 = __importDefault(require("@mui/icons-material/Home"));
var react_1 = __importDefault(require("react"));
var LevelBreadcrumb_1 = require("./LevelBreadcrumb");
function LevelSelector(_a) {
    var obj = _a.obj, path = _a.path, setPath = _a.setPath;
    var subobj = obj;
    var paths = path.map(function (pathItem) {
        var items = new Array();
        if (Array.isArray(subobj)) {
            var keys = Array.from(subobj.keys());
            var itemIndex = parseInt(pathItem.toString(), 10);
            items = __spreadArray(__spreadArray([], __read(keys.slice(0, itemIndex)), false), __read(keys.slice(itemIndex + 1)), false);
            subobj = subobj[itemIndex];
        }
        else if (typeof subobj === 'object' && subobj !== null) {
            var keys = new Set(Object.keys(subobj));
            keys.delete(pathItem.toString());
            items = Array.from(keys);
            subobj = subobj[pathItem];
        }
        return {
            items: items,
            pathItem: pathItem,
        };
    });
    return (react_1.default.createElement(material_1.Breadcrumbs, { "aria-label": "breadcrumb" },
        react_1.default.createElement(LevelBreadcrumb_1.LevelBreadcrumb, { item: "Root", icon: react_1.default.createElement(Home_1.default, { fontSize: "small" }), onSelect: function () { return setPath([]); } }),
        paths.map(function (pathPart, index) { return (react_1.default.createElement(LevelBreadcrumb_1.LevelBreadcrumb, { key: pathPart.pathItem, item: pathPart.pathItem, onSelect: function (selectedItem) { return setPath(__spreadArray(__spreadArray([], __read(path.slice(0, index)), false), [selectedItem], false)); }, items: pathPart.items })); })));
}
exports.LevelSelector = LevelSelector;
